<template>
  <div class="navBox">
    <a-spin :spinning="spinFlag">
      <div class="selectBox">
        <div class="title-1">{{ $t('public.subject') }}</div>
        <div class="option-title">{{ $t('public.academicYear') }}</div>
        <a-select
          showSearch
          v-model="academic"
          style="width: 100%;margin-bottom:5px"
          :placeholder="$t('public.academicYear')"
          :dropdownMatchSelectWidth="false"
        >
          <a-select-option
            v-for="(item, index) in academicYearList"
            :key="index"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
        <div class="option-title">{{ $t('public.semester') }}</div>
        <a-select
          showSearch
          v-model="semester"
          style="width: 100%;margin-bottom:5px"
          :placeholder="$t('public.semester')"
          :dropdownMatchSelectWidth="false"
        >
          <a-select-option
            v-for="(item, index) in semesterList"
            :key="index"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </div>
      <a-collapse
        v-model="activeKey"
        :bordered="false"
        :expand-icon-position="expandIconPosition"
      >
        <a-collapse-panel
          v-for="(item, index) in pageData"
          :key="item.name"
          :header="item.name"
        >
          <template>
            <div class="list">
              <div
                class="courseNameItem"
                v-for="(itemJ, idx) in item.list"
                :key="itemJ.id"
              >
                <div class="typename">{{ itemJ.name }}</div>
                <div
                  class="listItem"
                  v-for="(itenl, indexOne) in itemJ.courses"
                  :key="itenl.id"
                  @click="btnItem(itenl, item.id, index, idx, indexOne, item)"
                >
                  <span>{{ itenl.name }}</span
                  ><span
                    ><svg
                      t="1625123395044"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2377"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M380.343 801.646a53.394 53.394 0 0 1-36.572-16.092L125.44 568.32a55.589 55.589 0 0 1 0-77.166 54.126 54.126 0 0 1 76.8 0l178.103 179.2L835.29 272.091a53.394 53.394 0 0 1 76.435 0 54.126 54.126 0 0 1 0 76.8L418.743 785.554a54.491 54.491 0 0 1-38.4 16.092z"
                        p-id="2378"
                        :fill="
                          itenl.clickedColor ? itenl.clickedColor : '#b0b0b0'
                        "
                      ></path></svg
                  ></span>
                </div>
              </div>
            </div>
          </template>
        </a-collapse-panel>
      </a-collapse>
    </a-spin>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      academic: undefined,
      activeKey: undefined,
      semester: undefined,
      expandIconPosition: 'right',
      tempData: [],
      pageData: [],
      parentIdsData: [],
      subjectData: [],
      spinFlag: false
    }
  },
  computed: {
    ...mapGetters(['academicYearList', 'semesterList', 'statisticsStatus'])
  },
  watch: {
    academic(val) {
      if (this.statisticsStatus == 1) {
        this.getNavListClass()
      } else if (this.statisticsStatus == 2) {
        this.getNavListGrade()
      }
      this.$store.commit('setCurrentAcademicYear', val)
      this.$emit('tab-data', {
        academic: this.academic,
        semester: this.semester
      })
    },
    semester(val) {
      if (this.statisticsStatus == 1) {
        this.getNavListClass()
      } else if (this.statisticsStatus == 2) {
        this.getNavListGrade()
      }
      this.$store.commit('setCurrentSemerter', val)
      this.$emit('tab-data', {
        academic: this.academic,
        semester: this.semester
      })
    },
    activeKey(ids) {
      let openId = ids[ids.length - 1]
      if (!openId) {
        return false
      } else {
        this.spinFlag = true
      }
      let itemData = this.pageData.find(Element => {
        return Element.name == openId
      })
      let Index = this.pageData.findIndex(Element => {
        return Element.name == openId
      })
      if (itemData.list) {
        this.spinFlag = false
        return false
      }

      if (!itemData.list) {
        if (this.statisticsStatus == 1) {
          let data = {
            academic: this.academic,
            semester: this.semester,
            classId: itemData.id
          }
          this.$http(this.$api.getCourseByIdClass, data).then(r => {
            // let data =
            let data = this.pageData
            data[Index].list = r.data
            this.pageData = []
            this.pageData = data
            this.spinFlag = false
          })
        } else if (this.statisticsStatus == 2) {
          let data = {
            grade: itemData.id,
            academic: this.academic,
            semester: this.semester
          }
          this.$http(this.$api.getListByGrade, data).then(r => {
            let data = this.pageData
            data[Index].list = r.data
            this.pageData = []
            this.pageData = data
            this.spinFlag = false
          })
        }
      }
    },
    //监听顶部导航栏数据变化
    statisticsStatus(val) {
      if (val == 1) {
        this.getNavListClass()
        this.$emit('headerTab-flag', val)
      } else if (val == 2) {
        this.$emit('headerTab-flag', val)
        this.getNavListGrade()
      }
    }
  },
  methods: {
    btnItem(item, parentId, index, idx, indexOne) {
      let replaceData = this.pageData
      if (this.tempData.length > 0 && parentId != this.parentIdsData[0]) {
        for (let h = 0; h < this.tempData.length; h++) {
          for (let i = 0; i < replaceData.length; i++) {
            if (replaceData[i].list) {
              for (let j = 0; j < replaceData[i].list.length; j++) {
                let itemL = replaceData[i].list[j].courses
                for (let k = 0; k < itemL.length; k++) {
                  // for (let h = 0; h < this.tempData.length; h++) {
                  if (this.tempData[h] == itemL[k].id) {
                    itemL[k].clickedColor = null
                    replaceData[i].list[j].courses[k] = itemL[k]
                  }
                }
              }
            }
          }
        }
        this.tempData = []
        this.parentIdsData = []
        this.parentIdsData.push(parentId)
      }
      let itemFlag = this.tempData.findIndex(Element => {
        return Element == item.id
      })
      let parentIdFlag = this.parentIdsData.findIndex(Element => {
        return Element == parentId
      })
      if (parentIdFlag == -1) {
        this.parentIdsData.push(parentId)
      }
      if (itemFlag == -1) {
        item.parentId = parentId
        item.clickedColor = '#484848'
        this.$set(replaceData[index].list[idx].courses, indexOne, item)
        this.tempData.push(item.id)
      } else {
        item.clickedColor = null
        this.$set(replaceData[index].list[idx].courses, indexOne, item)
        this.tempData.splice(itemFlag, 1)
      }

      this.pageData = []
      this.pageData = replaceData
      // if (this.tempData.length > 0) {
      let data = {
        parentId: this.parentIdsData[0],
        clickedData: this.tempData
      }
      this.$emit('leftCom-data', data)
      // }
    },
    getNavListClass() {
      this.$http(this.$api.getClassListAll).then(r => {
        this.pageData = r.data
      })
    },
    getNavListGrade() {
      this.$http(this.$api.getGradeListAll).then(r => {
        this.pageData = r.data
      })
    }
  },
  created() {
    this.academic =
      new Date().getFullYear() - 1 + '/' + new Date().getFullYear()
    this.semester = 1
    this.$emit('headerTab-flag', 1)
    this.$emit('tab-data', { academic: this.academic, semester: this.semester })
    this.$store.commit('setCurrentAcademicYear', this.academic)
    this.$store.commit('setCurrentSemerter', this.semester)
    this.getNavListClass()
  }
}
</script>
<style lang="less" scoped>
.navBox {
  width: 100%;
  height: 100%;
  padding: 10px 0 0 0px;
  box-sizing: border-box;
  border-right: 1px solid #e4e7ea;
  min-height: 100vh;
  padding-bottom: 20px;
  .loadingBox {
    position: absolute;
  }
  .selectBox {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    .title-1 {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
    }
    .option-title {
      margin-bottom: 5px;
      color: #9b9b9b;
    }
  }
  .typename {
    width: 100%;
    background-color: #f2f2f2;
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
  }
  .list {
    width: 100%;
    // padding-bottom: 10px;
    background-color: #fff;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    .courseNameItem {
      cursor: pointer;
      // padding-left: 10px;
      box-sizing: border-box;
      width: 100%;
      // height: 40px;
      line-height: 40px;
      background-color: #fff;
      border-bottom: 1px solid #e6e6e6;
      .listItem {
        padding-left: 10px;
        span:nth-child {
          width: 100%;
          overflow: hidden; /*超出部分隐藏*/
          white-space: nowrap; /*不换行*/
          text-overflow: ellipsis; /*超出部分文字以...显示*/
        }
      }
    }
    span {
      display: inline-block;
      vertical-align: top;
    }
    span:nth-child(1) {
      width: calc(100% - 30px);
      overflow: hidden; /*超出部分隐藏*/
      white-space: nowrap; /*不换行*/
      text-overflow: ellipsis; /*超出部分文字以...显示*/
    }
    span:last-child {
      width: 16px;
    }
  }
  /deep/ .ant-collapse-header {
    padding: 8px 10px !important;

    .ant-collapse-arrow {
      left: 160px !important;
    }
  }
  /deep/ .ant-collapse-content-box {
    padding: 0px !important;
  }

  /deep/ .ant-collapse-item {
    background-color: #f5f6fa;
    border-radius: 2px;
    border-bottom: none;
  }
  .ant-collapse-item:last-child > .ant-collapse-content {
    border-radius: 0px;
  }
  .ant-collapse {
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 10px;
  }
}
/deep/.ant-collapse-header {
  width: 171px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
</style>
